/* kjp-studio.js — custom-kit builder "kit studio" (12-Oct-2026, STAGING first; go-live re-applies)
   Panel-approved set: panel styles, granular colours, front-chest + sleeve numbers, sponsor / sleeve / back-neck logo
   slots, team crest maker, Home & Away (toggle, compare, quote both), kit-completeness meter, seeded "Surprise me" with
   undo, shareable 1080x1350 kit card.
   State: window.KJP_STUDIO (plain JSON; kjp.js puts it in the design link as "st", old links simply lack it and render
   exactly as before). The viewer (kjp-3d-v5.js) paints from it; logo-slot images live in KibiJersey3D.setSlot().
   Talks to kjp.js only through window.KJP_API, adds spec lines through window.KJP_STUDIO_DESC and files through a
   wrapper of window.KJP_QUOTE_EXTRAS (<= 8 attachments in total). Quote-only: no prices anywhere here.
   Any failure leaves the builder working as before. */
(function () {
  'use strict';
  var MAX_ATT = 8, IMG_MAX = 5 * 1024 * 1024, SNAP_MAX = 600 * 1024, MOQ = 10, UNDO_MAX = 10;
  var DEF = { primary: '#7C3AED', secondary: '#FFFFFF', accent: '#F59E0B' };
  var PANELS = [['none', 'None'], ['side', 'Side panels'], ['yoke', 'Shoulder yoke'], ['band', 'Chest band'], ['sash', 'Sash'],
    ['pin', 'Pinstripes'], ['hoops', 'Hoops'], ['fade', 'Fade']];
  var GKEYS = ['cc', 'rc', 'sc', 'nc', 'uc', 'oc'];
  var GLABEL = { cc: 'Collar', rc: 'Cuffs & rib', sc: 'Side panels', nc: 'Name text', uc: 'Number text', oc: 'Number outline' };
  var SLOTS = [['sp', 'Front sponsor', 'Centre chest, on the chest band'], ['sl', 'Sleeve logo', 'Left sleeve'], ['nk', 'Back-neck logo', 'Small, below the collar']];
  var SHAPES = ['shield', 'circle', 'diamond', 'hexagon'];
  var PLABEL = { jersey: 'Jersey', shorts: 'Shorts', pants: 'Long Pants', hoodie: 'Hoodie', tracksuit: 'Tracksuit' };

  /* ───────────── plumbing ───────────── */
  function api() { return window.KJP_API || null; }
  function S() { var a = api(); return a && a.S || null; }
  function K3() { return window.KibiJersey3D || null; }
  function cfgV() { var a = api(), v = a && a.cfg ? a.cfg() : null; return v && v.snap ? v : null; }
  function viewers() { var a = api(); return a ? [a.hero && a.hero(), a.cfg && a.cfg()].filter(Boolean) : []; }
  function ST() { var s = window.KJP_STUDIO; if (!s || typeof s !== 'object' || Array.isArray(s)) { s = {}; window.KJP_STUDIO = s; } return s; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, txt) { var e = document.createElement(tag); cls && (e.className = cls); txt != null && (e.textContent = txt); return e; }
  function attr(e, o) { for (var k in o) e.setAttribute(k, o[k]); return e; }
  function hexOk(h) { return typeof h === 'string' && /^#[0-9a-fA-F]{6}$/.test(h) ? h.toUpperCase() : null; }
  function rgb(h) { h = (h || '#000').replace('#', ''); return [parseInt(h.slice(0, 2), 16) || 0, parseInt(h.slice(2, 4), 16) || 0, parseInt(h.slice(4, 6), 16) || 0]; }
  function lum(h) { var c = rgb(h).map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]; }
  function cr(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function ink(bg) { return cr(bg, '#FFFFFF') >= cr(bg, '#111111') ? '#FFFFFF' : '#111111'; }
  function clean(o) { for (var k in o) if (o[k] == null || o[k] === '' || o[k] === 0 || o[k] === false) delete o[k]; return o; }
  function copy(o) { return JSON.parse(JSON.stringify(o || {})); }
  var rT = 0, mT = 0;
  function refresh() { var k = K3(); k && k.refreshAll && k.refreshAll(); }
  function refreshSoon() { clearTimeout(rT); rT = setTimeout(refresh, 70); meterSoon(); }   /* debounced canvas work */
  function meterSoon() { clearTimeout(mT); mT = setTimeout(meter, 160); }
  function svg(inner, vb) { return '<svg viewBox="' + (vb || '0 0 24 24') + '" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>'; }
  var IC = {
    dice: svg('<rect x="3" y="3" width="18" height="18" rx="4"/><circle cx="8.5" cy="8.5" r="1.2" fill="currentColor"/><circle cx="15.5" cy="15.5" r="1.2" fill="currentColor"/><circle cx="15.5" cy="8.5" r="1.2" fill="currentColor"/><circle cx="8.5" cy="15.5" r="1.2" fill="currentColor"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/>'),
    undo: svg('<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>'),
    card: svg('<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 15l2.5-3 2 2 3.5-4"/><path d="M8 7h5"/>'),
    swap: svg('<path d="M7 4 3 8l4 4"/><path d="M3 8h14"/><path d="m17 20 4-4-4-4"/><path d="M21 16H7"/>'),
    check: svg('<path d="m5 12 5 5L20 7"/>'),
    dl: svg('<path d="M12 4v11"/><path d="m7 10 5 5 5-5"/><path d="M5 20h14"/>')
  };

  /* colours: apply a full kit (colours + name/number colour + granular overrides) the way kjp.js's combo buttons do */
  function syncColourUI() {
    var s = S(); if (!s) return;
    ['primary', 'secondary', 'accent'].forEach(function (k) {
      var v = s.colors[k], inp = $('[data-kjp-color="' + k + '"]'), f = $('[data-kjp-fill="' + k + '"]'), hx = $('[data-kjp-hex="' + k + '"]');
      inp && (inp.value = v); f && (f.style.background = v); hx && (hx.textContent = String(v).toUpperCase());
    });
    var tc = s.textColor || s.colors.accent, ti = $('[data-kjp-color="textcol"]'), tf = $('[data-kjp-fill="textcol"]'), th = $('[data-kjp-hex="textcol"]');
    ti && (ti.value = tc); tf && (tf.style.background = tc); th && (th.textContent = String(tc).toUpperCase());
  }
  function applyKit(kit, now) {
    var s = S(), a = api(); if (!s || !kit) return;
    Object.assign(s.colors, kit.c);
    s.textColor = kit.tc || null;
    var st = ST(); GKEYS.forEach(function (k) { delete st[k]; }); Object.assign(st, kit.g || {});
    viewers().forEach(function (v) {
      v.setColorsNow ? v.setColorsNow(s.colors) : v.setColors(s.colors);   /* instant: an offscreen viewer never finishes a lerp */
      v.setText({ textColor: s.textColor || null });
    });
    syncColourUI(); a && a.render(); syncGranular(); refreshSoon();
  }
  function captureKit() { var s = S(), st = ST(), g = {}; GKEYS.forEach(function (k) { hexOk(st[k]) && (g[k] = st[k]); }); return { c: copy(s.colors), tc: s.textColor || null, g: g }; }

  /* ───────────── 1. panel styles ───────────── */
  var PN_SVG = {
    none: '',
    side: '<rect x="9" y="10" width="5" height="32"/><rect x="26" y="10" width="5" height="32"/>',
    yoke: '<rect x="0" y="0" width="40" height="13"/>',
    band: '<rect x="0" y="19" width="40" height="7"/>',
    sash: '<polygon points="10,2 17,2 33,40 26,42"/>',
    pin: '<rect x="12" y="0" width="1" height="44"/><rect x="16" y="0" width="1" height="44"/><rect x="20" y="0" width="1" height="44"/><rect x="24" y="0" width="1" height="44"/><rect x="28" y="0" width="1" height="44"/>',
    hoops: '<rect x="0" y="9" width="40" height="5"/><rect x="0" y="19" width="40" height="5"/><rect x="0" y="29" width="40" height="5"/>',
    fade: '<rect x="0" y="0" width="40" height="44" fill="url(#kjs-fd)" style="fill:url(#kjs-fd)"/>'
  };
  var SHIRT = 'M14 3 8 5 2 12l5 5 3-2v26h20V15l3 2 5-5-6-7-6-2c-1.6 3-3.4 4-6 4s-4.4-1-6-4z';
  function pnSwatch(id) {
    return '<svg viewBox="0 0 40 44" width="40" height="44" aria-hidden="true"><defs><clipPath id="kjs-cp-' + id + '"><path d="' + SHIRT + '"/></clipPath>' +
      (id === 'fade' ? '<linearGradient id="kjs-fd" x1="0" y1="0" x2="0" y2="1"><stop offset=".3" stop-color="var(--kjs-s)" stop-opacity="0"/><stop offset="1" stop-color="var(--kjs-s)"/></linearGradient>' : '') +
      '</defs><g clip-path="url(#kjs-cp-' + id + ')"><path d="' + SHIRT + '" style="fill:var(--kjs-p)"/><g style="fill:var(--kjs-s)">' + PN_SVG[id] + '</g></g>' +
      '<path d="' + SHIRT + '" fill="none" stroke="rgba(15,10,30,.28)" stroke-width="1"/></svg>';
  }
  var pnWrap = null;
  function buildPanels() {
    var anchor = $('.kjp-patterns'); if (!anchor) return;
    pnWrap = el('div', 'kjs-pn'); pnWrap.setAttribute('data-kjs-panels', '');
    var lb = el('p', 'kjp-sub-lbl', 'Panel style'); lb.id = 'kjs-pn-lbl'; pnWrap.appendChild(lb);
    var row = attr(el('div', 'kjs-pn__row'), { role: 'radiogroup', 'aria-labelledby': 'kjs-pn-lbl' });
    PANELS.forEach(function (p) {
      var b = attr(el('button', 'kjs-pn__b'), { type: 'button', role: 'radio', 'data-kjs-pn': p[0], 'aria-checked': 'false' });
      b.innerHTML = '<span class="kjs-pn__sw">' + pnSwatch(p[0]) + '</span><span class="kjs-pn__nm"></span>';
      b.lastChild.textContent = p[1];
      b.addEventListener('click', function () { pushUndoMaybe(); var st = ST(); p[0] === 'none' ? delete st.pn : (st.pn = p[0]); touched.style = 1; syncPanels(); refreshSoon(); });
      row.appendChild(b);
    });
    pnWrap.appendChild(row);
    pnWrap.appendChild(el('p', 'kjp-hint kjs-pn__hint', 'Panels use your Side panels colour and work with every base style. Bottoms take side panels, pinstripes, hoops and fade.'));
    anchor.parentNode.insertBefore(pnWrap, anchor.nextSibling);
  }
  function syncPanels() {
    if (!pnWrap) return;
    var s = S(), st = ST(), pn = st.pn || 'none';
    if (s) { pnWrap.style.setProperty('--kjs-p', s.colors.primary); pnWrap.style.setProperty('--kjs-s', hexOk(st.sc) || s.colors.secondary); }
    $$('[data-kjs-pn]', pnWrap).forEach(function (b) { var on = b.getAttribute('data-kjs-pn') === pn; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
  }

  /* ───────────── 2. granular colours ───────────── */
  var gWrap = null;
  function derived(k) {
    var s = S(); if (!s) return '#000000';
    var c = s.colors, t = s.textColor || (s.premium ? '#FFFFFF' : c.accent), tfx = window.KJP_TFX || {};
    return hexOk({ cc: s.product === 'tracksuit' ? c.secondary : c.accent, rc: c.accent, sc: c.secondary, nc: t, uc: t,
      oc: tfx.oc || c.secondary }[k]) || '#000000';
  }
  function buildGranular() {
    var anchor = $('.kjp-colors'); if (!anchor) return;
    gWrap = el('details', 'kjs-more'); gWrap.setAttribute('data-kjs-granular', '');
    var sm = el('summary', null, 'More colours'); sm.appendChild(el('span', 'kjs-more__sub', 'collar, cuffs, panels, name, number, outline'));
    gWrap.appendChild(sm);
    var grid = el('div', 'kjs-g');
    GKEYS.forEach(function (k) {
      var row = el('div', 'kjs-g__row'); row.setAttribute('data-kjs-g', k);
      var lab = el('label', 'kjs-g__lbl', GLABEL[k]); lab.htmlFor = 'kjs-g-' + k;
      var sw = el('span', 'kjs-g__sw'), inp = attr(el('input'), { type: 'color', id: 'kjs-g-' + k, 'data-kjs-gc': k });
      sw.appendChild(inp);
      var hx = el('span', 'kjs-g__hex'), auto = attr(el('button', 'kjs-g__auto', 'Auto'), { type: 'button', 'data-kjs-gauto': k, 'aria-label': GLABEL[k] + ': back to automatic colour' });
      row.appendChild(lab); row.appendChild(sw); row.appendChild(hx); row.appendChild(auto); grid.appendChild(row);
      inp.addEventListener('input', function () { ST()[k] = inp.value.toUpperCase(); syncGranular(); refreshSoon(); });
      auto.addEventListener('click', function () { delete ST()[k]; syncGranular(); refreshSoon(); });
    });
    gWrap.appendChild(grid);
    gWrap.appendChild(el('p', 'kjp-hint', 'Auto follows your main colours. Pick one to set it on its own.'));
    anchor.parentNode.insertBefore(gWrap, anchor.nextSibling);
  }
  function syncGranular() {
    if (!gWrap) return;
    var st = ST();
    GKEYS.forEach(function (k) {
      var row = $('[data-kjs-g="' + k + '"]', gWrap); if (!row) return;
      var set = hexOk(st[k]), v = set || derived(k);
      $('input', row).value = v.toLowerCase(); $('.kjs-g__sw', row).style.background = v;
      $('.kjs-g__hex', row).textContent = set ? v : 'Auto · ' + v;
      row.classList.toggle('is-set', !!set); $('.kjs-g__auto', row).hidden = !set;
    });
    syncPanels();
  }

  /* ───────────── 3. number positions ───────────── */
  function buildNumbers() {
    var num = $('[data-kjp-num]'), field = num && num.closest('.kjp-field'); if (!field) return;
    var w = el('div', 'kjs-np'); w.setAttribute('data-kjs-numpos', '');
    w.appendChild(el('span', 'kjp-sub-lbl', 'Number positions'));
    var row = attr(el('div', 'kjp-toggles kjs-np__row'), { role: 'group', 'aria-label': 'Number positions' });
    [['bk', 'Back'], ['fn', 'Front chest'], ['sn', 'Sleeve']].forEach(function (p) {
      var b = attr(el('button', 'kjp-toggle', p[1]), { type: 'button', 'data-kjs-np': p[0], 'aria-pressed': 'false' });
      if (p[0] === 'bk') { b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); b.disabled = true; b.title = 'Back number is always printed'; }
      else b.addEventListener('click', function () { var st = ST(); st[p[0]] ? delete st[p[0]] : (st[p[0]] = 1); syncNumbers(); refreshSoon(); });
      row.appendChild(b);
    });
    w.appendChild(row);
    w.appendChild(el('p', 'kjp-hint', 'Front chest number sits opposite your chest logo. Sleeve number goes on the right sleeve. Each player gets their own number from the roster.'));
    field.parentNode.insertBefore(w, field.nextSibling);
  }
  function syncNumbers() {
    var st = ST();
    $$('[data-kjs-np]').forEach(function (b) { var k = b.getAttribute('data-kjs-np'); if (k === 'bk') return; b.classList.toggle('on', !!st[k]); b.setAttribute('aria-pressed', st[k] ? 'true' : 'false'); });
  }

  /* ───────────── 4. sponsor / sleeve / back-neck logo slots ───────────── */
  var slotFiles = {};  /* name -> File (images only), sent with the quote */
  function buildSlots(after) {
    var w = el('div', 'kjs-slots'); w.setAttribute('data-kjs-slots', '');
    w.appendChild(el('span', 'kjp-sub-lbl', 'Sponsor & extra logos'));
    SLOTS.forEach(function (sl) {
      var row = el('div', 'kjs-slot'); row.setAttribute('data-kjs-slot', sl[0]);
      var th = el('span', 'kjs-slot__th'), im = attr(el('img'), { alt: '', width: '40', height: '40' }); im.hidden = true; th.appendChild(im);
      var tx = el('span', 'kjs-slot__tx'); tx.appendChild(el('strong', null, sl[1])); tx.appendChild(el('span', 'kjs-slot__st', sl[2]));
      var inp = attr(el('input'), { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/svg+xml', hidden: '', 'aria-label': sl[1] + ' image' });
      var up = attr(el('button', 'kjs-slot__btn', 'Upload'), { type: 'button' }), rm = attr(el('button', 'kjs-slot__rm', 'Remove'), { type: 'button', 'aria-label': 'Remove ' + sl[1] });
      rm.hidden = true;
      row.appendChild(th); row.appendChild(tx); row.appendChild(up); row.appendChild(rm); row.appendChild(inp); w.appendChild(row);
      up.addEventListener('click', function () { inp.click(); });
      rm.addEventListener('click', function () { setSlot(sl[0], null); });
      inp.addEventListener('change', function () { var f = inp.files && inp.files[0]; inp.value = ''; f && setSlot(sl[0], f); });
    });
    var msg = attr(el('p', 'kjs-slots__msg'), { 'aria-live': 'polite' }); w.appendChild(msg);
    w.appendChild(el('p', 'kjp-hint', 'Images only: PNG, JPG, WebP or SVG, up to 5 MB. They are sent with your quote request.'));
    after.parentNode.insertBefore(w, after.nextSibling);
    return w;
  }
  function setSlot(name, f) {
    var row = $('[data-kjs-slot="' + name + '"]'), msg = $('.kjs-slots__msg'), k = K3();
    msg && (msg.textContent = '');
    if (!f) { delete slotFiles[name]; k && k.setSlot && k.setSlot(name, null); paintSlot(row, null); meterSoon(); return; }
    if (!/^image\/(png|jpeg|webp|svg\+xml)$/.test(f.type)) { msg && (msg.textContent = f.name + ' is not an image. Use PNG, JPG, WebP or SVG.'); return; }
    if (f.size > IMG_MAX) { msg && (msg.textContent = f.name + ' is over 5 MB. Please use a smaller image.'); return; }
    var rd = new FileReader();
    rd.onload = function () { slotFiles[name] = f; k && k.setSlot && k.setSlot(name, rd.result); paintSlot(row, rd.result, f.name); meterSoon(); };
    rd.readAsDataURL(f);
  }
  function paintSlot(row, url, nm) {
    if (!row) return;
    var im = $('img', row), st = $('.kjs-slot__st', row), def = (SLOTS.filter(function (s) { return s[0] === row.getAttribute('data-kjs-slot'); })[0] || [])[2];
    im.hidden = !url; url ? (im.src = url, im.alt = nm || '') : im.removeAttribute('src');
    st.textContent = url ? nm : def; $('.kjs-slot__rm', row).hidden = !url; $('.kjs-slot__btn', row).textContent = url ? 'Replace' : 'Upload';
    row.classList.toggle('is-set', !!url);
  }

  /* ───────────── 5. team crest maker ───────────── */
  var crWrap = null;
  function crestParams() { var s = S(), c = ST().cr || {}; return { s: c.s || 'shield', t: c.t != null ? c.t : '', a: hexOk(c.a) || (s ? s.colors.primary : DEF.primary), b: hexOk(c.b) || (s ? s.colors.secondary : DEF.secondary), on: c.on ? 1 : 0 }; }
  function crestInitials() { var s = S(), n = (s && s.name || '').replace(/[^A-Za-z0-9 ]/g, ' ').trim().split(/\s+/).filter(Boolean); return (n.length > 1 ? n.slice(0, 3).map(function (w) { return w[0]; }).join('') : (n[0] || 'KFC').slice(0, 3)).toUpperCase(); }
  function buildCrest(after) {
    crWrap = el('details', 'kjs-crest'); crWrap.setAttribute('data-kjs-crest', '');
    var sm = el('summary', null, 'No logo yet? Make a team crest'); crWrap.appendChild(sm);
    var body = el('div', 'kjs-crest__body');
    var cv = attr(el('canvas', 'kjs-crest__pv'), { width: '192', height: '192', role: 'img', 'aria-label': 'Crest preview' });
    var form = el('div', 'kjs-crest__form');
    var shp = attr(el('div', 'kjs-crest__shapes'), { role: 'radiogroup', 'aria-label': 'Crest shape' });
    SHAPES.forEach(function (s) {
      var b = attr(el('button', 'kjs-crest__shape'), { type: 'button', role: 'radio', 'data-kjs-cs': s, 'aria-label': s, title: s.charAt(0).toUpperCase() + s.slice(1) });
      var c = attr(el('canvas'), { width: '56', height: '56', 'aria-hidden': 'true' }); b.appendChild(c); shp.appendChild(b);
      b.addEventListener('click', function () { setCrest({ s: s }); });
    });
    var ini = attr(el('input', 'kjp-input kjs-crest__ini'), { type: 'text', maxlength: '3', autocomplete: 'off', spellcheck: 'false', id: 'kjs-cr-t', placeholder: 'KFC', 'aria-label': 'Crest initials (1 to 3)' });
    var la = el('label', 'kjs-crest__lab', 'Initials'); la.htmlFor = 'kjs-cr-t';
    var cols = el('div', 'kjs-crest__cols');
    [['a', 'Fill'], ['b', 'Letters & border']].forEach(function (p) {
      var l = el('label', 'kjs-crest__col'), sw = el('span', 'kjs-g__sw'), i = attr(el('input'), { type: 'color', 'data-kjs-cc': p[0], 'aria-label': 'Crest ' + p[1].toLowerCase() + ' colour' });
      sw.appendChild(i); l.appendChild(sw); l.appendChild(document.createTextNode(p[1])); cols.appendChild(l);
      i.addEventListener('input', function () { var o = {}; o[p[0]] = i.value.toUpperCase(); setCrest(o); });
    });
    ini.addEventListener('input', function () { setCrest({ t: ini.value.toUpperCase().replace(/[^A-Z0-9&]/g, '').slice(0, 3) }); });
    var acts = el('div', 'kjs-crest__acts');
    var use = attr(el('button', 'kjs-btn kjs-btn--pri', 'Use as chest logo'), { type: 'button', 'data-kjs-crest-use': '', 'aria-pressed': 'false' });
    var dl = attr(el('button', 'kjs-btn'), { type: 'button', 'data-kjs-crest-dl': '' }); dl.innerHTML = IC.dl + '<span>Download PNG</span>';
    use.addEventListener('click', function () { var on = !crestParams().on; setCrest({ on: on ? 1 : 0, t: crestParams().t || crestInitials() }); touched.logo = 1; });
    dl.addEventListener('click', downloadCrest);
    acts.appendChild(use); acts.appendChild(dl);
    form.appendChild(el('span', 'kjp-sub-lbl', 'Shape')); form.appendChild(shp); form.appendChild(la); form.appendChild(ini); form.appendChild(cols); form.appendChild(acts);
    body.appendChild(cv); body.appendChild(form); crWrap.appendChild(body);
    crWrap.appendChild(attr(el('p', 'kjp-hint kjs-crest__note'), { 'aria-live': 'polite' }));
    crWrap.addEventListener('toggle', function () { crWrap.open && syncCrest(); });
    after.parentNode.insertBefore(crWrap, after.nextSibling);
  }
  function setCrest(o) {
    var st = ST(), p = crestParams(); Object.assign(p, o); if (!p.t) p.t = crestInitials();
    st.cr = { s: p.s, t: p.t, a: p.a, b: p.b }; p.on && (st.cr.on = 1);
    syncCrest(); refreshSoon();
  }
  function syncCrest() {
    if (!crWrap) return;
    var p = crestParams(), k = K3(), s = S();
    if (!p.t) p.t = crestInitials();
    var pv = $('.kjs-crest__pv', crWrap);
    if (crWrap.open && k && k.crest) {
      var g = pv.getContext('2d'); g.clearRect(0, 0, 192, 192); g.drawImage(k.crest(p, 384), 0, 0, 192, 192);
      $$('[data-kjs-cs]', crWrap).forEach(function (b) { var c = $('canvas', b), x = c.getContext('2d'); x.clearRect(0, 0, 56, 56); x.drawImage(k.crest({ s: b.getAttribute('data-kjs-cs'), t: p.t, a: p.a, b: p.b }, 112), 0, 0, 56, 56); });
    }
    $$('[data-kjs-cs]', crWrap).forEach(function (b) { var on = b.getAttribute('data-kjs-cs') === p.s; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var ini = $('.kjs-crest__ini', crWrap); document.activeElement !== ini && (ini.value = (ST().cr && ST().cr.t) || '');
    ini.placeholder = crestInitials();
    $$('[data-kjs-cc]', crWrap).forEach(function (i) { i.value = p[i.getAttribute('data-kjs-cc')].toLowerCase(); i.parentNode.style.background = p[i.getAttribute('data-kjs-cc')]; });
    var use = $('[data-kjs-crest-use]', crWrap); use.textContent = p.on ? 'Crest is your chest logo' : 'Use as chest logo'; use.classList.toggle('on', !!p.on); use.setAttribute('aria-pressed', p.on ? 'true' : 'false');
    var note = $('.kjs-crest__note', crWrap);
    note.textContent = p.on && s && s.logo ? 'You have uploaded a logo, so the 3D model shows that. The crest is still sent with your quote.' : p.on ? 'The crest is on the chest. Upload a logo any time to replace it.' : '';
  }
  function crestFile() {
    var p = crestParams(), k = K3(); if (!p.on || !k || !k.crest) return null;
    try { var d = k.crest(p, 1024).toDataURL('image/png'); return toFile(dataUrlToBlob(d), 'team-crest.png'); } catch (e) { return null; }
  }
  function downloadCrest() { var f = crestFile() || (function () { var k = K3(), p = crestParams(); if (!p.t) p.t = crestInitials(); try { return toFile(dataUrlToBlob(k.crest(p, 1024).toDataURL('image/png')), 'team-crest.png'); } catch (e) { return null; } })(); f && saveBlob(f, 'team-crest.png'); }

  /* ───────────── 6. Home & Away ───────────── */
  var haWrap = null;
  function awayOf(kit) {
    var c = kit.c, p = c.primary, s = c.secondary, a = c.accent, out;
    if (cr(p, s) >= 1.8) out = { primary: s, secondary: p, accent: cr(a, s) >= 2 ? a : p };
    else { var np = lum(p) > 0.4 ? '#111827' : '#FFFFFF'; out = { primary: np, secondary: p, accent: cr(a, np) >= 2 ? a : p }; }
    var g = {}, kg = kit.g || {};
    ['cc', 'rc', 'oc'].forEach(function (k) { kg[k] && (g[k] = kg[k]); });
    ['nc', 'uc'].forEach(function (k) { kg[k] && cr(kg[k], out.primary) >= 2.5 && (g[k] = kg[k]); });
    var tc = kit.tc && cr(kit.tc, out.primary) >= 2.5 ? kit.tc : (cr(out.accent, out.primary) >= 2.5 ? null : (cr(p, out.primary) >= 2.5 ? p : ink(out.primary)));
    return { c: out, tc: tc || null, g: g };
  }
  function buildHomeAway() {
    var cp = $('.kjp-colors'), panel = cp && cp.closest('.kjp-panel'); if (!panel) return;
    haWrap = el('div', 'kjs-ha'); haWrap.setAttribute('data-kjs-ha', '');
    var head = el('div', 'kjs-ha__head'); head.appendChild(el('span', 'kjp-sub-lbl', 'Home & Away'));
    haWrap.appendChild(head);
    var make = attr(el('button', 'kjs-btn kjs-btn--pri'), { type: 'button', 'data-kjs-ha-make': '' }); make.innerHTML = IC.swap + '<span>Create away kit</span>';
    var seg = attr(el('div', 'kjs-seg'), { role: 'radiogroup', 'aria-label': 'Show home or away kit' });
    [['h', 'Home'], ['a', 'Away']].forEach(function (p) { var b = attr(el('button', 'kjs-seg__b', p[1]), { type: 'button', role: 'radio', 'data-kjs-ha-k': p[0] }); seg.appendChild(b); b.addEventListener('click', function () { (ST().k || 'h') !== p[0] && toggleKit(); }); });
    var cmp = attr(el('button', 'kjs-btn', 'Compare'), { type: 'button', 'data-kjs-ha-cmp': '' });
    var rm = attr(el('button', 'kjs-btn kjs-btn--ghost', 'Remove away kit'), { type: 'button', 'data-kjs-ha-rm': '' });
    var qb = el('label', 'kjs-check'), qi = attr(el('input'), { type: 'checkbox', 'data-kjs-ha-qb': '' });
    qb.appendChild(qi); qb.appendChild(document.createTextNode('Quote both kits'));
    var row = el('div', 'kjs-ha__row'); row.appendChild(make); row.appendChild(seg); row.appendChild(cmp); row.appendChild(qb); row.appendChild(rm);
    haWrap.appendChild(row);
    var fig = el('div', 'kjs-ha__cmp'); fig.hidden = true; fig.setAttribute('data-kjs-ha-fig', ''); haWrap.appendChild(fig);
    haWrap.appendChild(el('p', 'kjp-hint', 'The away kit swaps your main colours and keeps the design, logos and roster. Edit either kit; switch with Home / Away.'));
    make.addEventListener('click', function () { var st = ST(); if (st.alt) return; pushUndoMaybe(); var home = captureKit(); st.alt = home; st.k = 'a'; applyKit(awayOf(home)); st.qb = 1; syncHA(); });
    cmp.addEventListener('click', compare);
    rm.addEventListener('click', function () { var st = ST(); if (!st.alt) return; if (st.k === 'a') applyKit(st.alt); delete st.alt; delete st.k; delete st.qb; fig.hidden = true; syncHA(); });
    qi.addEventListener('change', function () { qi.checked ? (ST().qb = 1) : delete ST().qb; syncHA(); });
    panel.appendChild(haWrap);
  }
  function toggleKit() { var st = ST(); if (!st.alt) return; var cur = captureKit(), nxt = st.alt; st.alt = cur; st.k = st.k === 'a' ? 'h' : 'a'; applyKit(nxt); syncHA(); var f = $('[data-kjs-ha-fig]'); f && !f.hidden && compare(); }
  function syncHA() {
    if (!haWrap) return;
    var st = ST(), has = !!st.alt, k = st.k || 'h';
    $('[data-kjs-ha-make]', haWrap).hidden = has;
    ['.kjs-seg', '[data-kjs-ha-cmp]', '[data-kjs-ha-rm]', '.kjs-check'].forEach(function (s) { $(s, haWrap).hidden = !has; });
    $$('[data-kjs-ha-k]', haWrap).forEach(function (b) { var on = b.getAttribute('data-kjs-ha-k') === k; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    $('[data-kjs-ha-qb]', haWrap).checked = !!st.qb;
    !has && ($('[data-kjs-ha-fig]', haWrap).hidden = true);
    meterSoon();
  }
  /* render the stored other kit on the configurator viewer synchronously, snap, and restore (no lerp, no flash) */
  /* the viewer only advances its colour lerp while on screen: settle it before any snapshot */
  function flush() { var v = cfgV(), s = S(); v && s && v.setColorsNow && v.setColorsNow(s.colors); }
  function withAlt(fn) {
    var st = ST(), v = cfgV(), s = S(); if (!st.alt || !v || !s) return null;
    flush();
    var cur = captureKit(), alt = st.alt, out = null;
    try {
      GKEYS.forEach(function (k) { delete st[k]; }); Object.assign(st, alt.g || {});
      v.setText({ textColor: alt.tc || null }); v.setColorsNow ? v.setColorsNow(alt.c) : v.setColors(alt.c);
      out = fn(v);
    } catch (e) { out = null; }
    finally {
      GKEYS.forEach(function (k) { delete st[k]; }); Object.assign(st, cur.g);
      v.setText({ textColor: cur.tc || null }); v.setColorsNow ? v.setColorsNow(cur.c) : v.setColors(cur.c);
    }
    return out;
  }
  function jpegOf(c, max) { if (!c) return null; for (var q = 0.86; q > 0.3; q -= 0.12) { var d = c.toDataURL('image/jpeg', q); if (bytesOf(d) <= (max || SNAP_MAX)) return d; } return null; }
  function compare() {
    var fig = $('[data-kjs-ha-fig]'), v = cfgV(); if (!fig || !v) return;
    flush(); var st = ST(), curD = jpegOf(v.snap('front', 520, '#F4F2FA')), altD = withAlt(function (vv) { return jpegOf(vv.snap('front', 520, '#F4F2FA')); });
    if (!curD || !altD) { fig.hidden = true; return; }
    var home = st.k === 'a' ? altD : curD, away = st.k === 'a' ? curD : altD;
    fig.replaceChildren();
    [['Home', home], ['Away', away]].forEach(function (p) { var f = el('figure', 'kjs-ha__f'), im = attr(el('img'), { src: p[1], alt: p[0] + ' kit, front', width: '260', height: '260' }); f.appendChild(im); f.appendChild(el('figcaption', null, p[0])); fig.appendChild(f); });
    fig.hidden = false;
  }

  /* ───────────── 7. kit-completeness meter ───────────── */
  var mWrap = null, touched = { colors: 0, style: 0, logo: 0 }, wasDone = null;
  function sizesTotal() { var s = S(); if (!s) return 0; var t = 0; for (var k in s.sizes) t += +s.sizes[k] || 0; return t; }
  function checks() {
    var s = S(), st = ST(); if (!s) return [];
    var c = s.colors, colDiff = ['primary', 'secondary', 'accent'].some(function (k) { return String(c[k]).toUpperCase() !== DEF[k]; });
    var mk = window.KJP_CUSTOMBULK && window.KJP_CUSTOMBULK.chosen ? window.KJP_CUSTOMBULK.chosen().length : 0;
    return [
      { k: 'colors', t: 'Team colours', ok: colDiff || !!touched.colors || GKEYS.some(function (k) { return !!hexOk(st[k]); }), go: '.kjp-colors' },
      { k: 'style', t: 'Pattern or panel style', ok: s.pattern !== 'solid' || !!s.premium || (st.pn && st.pn !== 'none') || !!touched.style, go: '.kjp-patterns' },
      { k: 'name', t: 'Name & number', ok: !!(s.name && String(s.name).trim()) && !!(s.number && String(s.number).trim()), go: '[data-kjp-name]' },
      { k: 'logo', t: 'Logo or crest', ok: !!s.logo || !!(st.cr && st.cr.on), go: '[data-kjp-upload-area]' },
      { k: 'squad', t: 'Squad of ' + MOQ + '+ (sizes)', ok: sizesTotal() >= MOQ, go: '.kjp-sizes-wrap' },
      { k: 'bonus', t: 'Bonus: away or matching kit', ok: !!st.alt || mk > 0, bonus: 1, go: '[data-kjs-ha]' }
    ];
  }
  function buildMeter() {
    var pc = $('.kjp-cfg__panels'); if (!pc) return;   /* top of the options column: the sticky viewer column is taller than a desktop viewport */
    mWrap = el('section', 'kjs-meter'); attr(mWrap, { 'data-kjs-meter': '', 'aria-labelledby': 'kjs-m-h' });
    mWrap.innerHTML = '<div class="kjs-meter__top"><svg class="kjs-ring" viewBox="0 0 44 44" width="48" height="48" aria-hidden="true"><circle cx="22" cy="22" r="18" class="kjs-ring__bg"/><circle cx="22" cy="22" r="18" class="kjs-ring__fg" transform="rotate(-90 22 22)"/></svg>' +
      '<div class="kjs-meter__txt"><h3 class="kjs-meter__h" id="kjs-m-h"></h3><p class="kjs-meter__next"></p></div>' +
      '<button type="button" class="kjs-btn kjs-btn--pri kjs-meter__cta" data-kjs-meter-cta hidden>Request quote</button></div>' +
      '<details class="kjs-meter__list"><summary>Checklist</summary><ul></ul></details>';
    pc.insertBefore(mWrap, pc.firstChild);
    $('[data-kjs-meter-cta]', mWrap).addEventListener('click', function () { var q = $('[data-kjp-quote-btn]'); if (!q) return; q.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { q.click(); }, 350); });
    $('ul', mWrap).addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-kjs-go]'); if (!b) return;
      var t = $(b.getAttribute('data-kjs-go')); t && t.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }
  function meter() {
    if (!mWrap) return;
    var cs = checks(), req = cs.filter(function (c) { return !c.bonus; }), done = req.filter(function (c) { return c.ok; }).length, all = done === req.length;
    var fg = $('.kjs-ring__fg', mWrap), C = 2 * Math.PI * 18;
    fg.style.strokeDasharray = C.toFixed(2); fg.style.strokeDashoffset = (C * (1 - done / req.length)).toFixed(2);
    mWrap.classList.toggle('is-complete', all);
    $('.kjs-meter__h', mWrap).textContent = all ? 'Kit complete' : 'Your kit: ' + done + ' of ' + req.length;
    var nx = req.filter(function (c) { return !c.ok; })[0];
    $('.kjs-meter__next', mWrap).textContent = all ? 'Everything we need for a quote and a sample.' : 'Next: ' + nx.t.toLowerCase();
    $('[data-kjs-meter-cta]', mWrap).hidden = !all;
    var ul = $('ul', mWrap); ul.replaceChildren();
    cs.forEach(function (c) {
      var li = el('li', 'kjs-meter__i' + (c.ok ? ' ok' : '') + (c.bonus ? ' bonus' : ''));
      var b = attr(el('button', null), { type: 'button', 'data-kjs-go': c.go });
      b.innerHTML = '<span class="kjs-meter__dot" aria-hidden="true">' + (c.ok ? IC.check : '') + '</span>';
      b.appendChild(el('span', null, c.t)); b.appendChild(el('span', 'kjs-sr', c.ok ? ' (done)' : ' (to do)'));
      li.appendChild(b); ul.appendChild(li);
    });
    var qb = $('[data-kjp-quote-btn]'); qb && qb.classList.toggle('kjs-ready', all);
    var nudge = $('[data-kjs-nudge]'); nudge && (nudge.hidden = !all);
    wasDone = all;
  }
  function buildNudge() {
    var ctas = $('.kjp-order .kjp-ctas'); if (!ctas) return;
    var p = attr(el('p', 'kjs-nudge', 'Kit complete. Request your quote for pricing and a digital sample.'), { 'data-kjs-nudge': '' }); p.hidden = true;
    ctas.parentNode.insertBefore(p, ctas);
  }

  /* ───────────── 8. Surprise me (seeded) + undo ───────────── */
  var PAL = ['#1B2A4E', '#1E3A8A', '#0EA5E9', '#C8102E', '#7F1D1D', '#EA580C', '#FACC15', '#166534', '#059669', '#111111', '#FFFFFF', '#7C3AED', '#4C1D95', '#0F766E', '#DB2777', '#6B7280', '#C9A227', '#F1F5F9'];
  var PATS = ['solid', 'solid', 'solid', 'geometric', 'halftone', 'grunge', 'camo'];
  var PNS = ['none', 'side', 'yoke', 'band', 'sash', 'pin', 'hoops', 'fade', 'side', 'band'];
  var FONTS = ['block', 'condensed', 'rounded', 'stencil', 'serif', 'anton', 'oswald', 'teko', 'russo', 'varsity', 'blackops'];
  function mulberry(a) { return function () { a |= 0; a = a + 1831565813 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function roll(seed) {
    var r = mulberry(seed), pick = function (arr) { return arr[Math.floor(r() * arr.length)]; }, p, s, a, n = 0;
    p = pick(PAL);
    do { s = pick(PAL); n++; } while ((s === p || cr(p, s) < 2.2) && n < 40);
    n = 0; do { a = pick(PAL); n++; } while ((a === p || cr(a, p) < 3) && n < 40);
    if (cr(a, p) < 3) a = ink(p);
    var fonts = (K3() && K3().fonts ? K3().fonts() : FONTS).filter(function (f) { return FONTS.indexOf(f) >= 0; });
    return { c: { primary: p, secondary: s, accent: a }, pattern: pick(PATS), pn: pick(PNS), font: pick(fonts.length ? fonts : FONTS) };
  }
  var undo = [], pendingUndo = 0;
  function snapState() { var s = S(); return { kit: captureKit(), pattern: s.pattern, premium: s.premium || null, font: s.font, st: copy(ST()) }; }
  function pushUndo() { if (!S()) return; undo.push(snapState()); undo.length > UNDO_MAX && undo.shift(); syncUndo(); }
  function pushUndoMaybe() { /* only design-changing studio actions that are not rolls: keep the last state reachable */ if (!pendingUndo) { pushUndo(); pendingUndo = 1; setTimeout(function () { pendingUndo = 0; }, 800); } }
  function clickPattern(pat, prem) {
    var b = prem ? $('[data-kjp-premium="' + prem + '"]') : null;
    if (b) { b.click(); return; }
    var pb = $('[data-kjp-pattern="' + (pat || 'solid') + '"]'); pb && pb.click();
  }
  function setFont(f) { var b = $('[data-kjp-font="' + f + '"]'); b && b.click(); }
  function restoreState(x) {
    window.KJP_STUDIO = copy(x.st);   /* logo-slot images are not part of the undo state */
    applyKit(x.kit);
    var s = S(); (s.pattern !== x.pattern || (s.premium || null) !== x.premium) && clickPattern(x.pattern, x.premium);
    s.font !== x.font && setFont(x.font);
    syncAll(); refreshSoon();
  }
  function surprise() {
    var s = S(); if (!s) return;
    pushUndo();
    var seed = (Math.random() * 4294967296) >>> 0 || 1, R = roll(seed), st = ST();
    GKEYS.forEach(function (k) { delete st[k]; });
    R.pn === 'none' ? delete st.pn : (st.pn = R.pn);
    st.sd = seed;
    applyKit({ c: R.c, tc: null, g: {} });
    clickPattern(R.pattern, null);
    setFont(R.font);
    touched.colors = touched.style = 1;
    syncAll(); refreshSoon();
    var live = $('[data-kjs-live]'); live && (live.textContent = 'New kit: ' + R.pattern + (R.pn !== 'none' ? ', ' + R.pn : '') + ' in ' + R.c.primary + ' / ' + R.c.secondary + '. Undo is available.');
  }
  function syncUndo() { $$('[data-kjs-undo]').forEach(function (b) { b.disabled = !undo.length; b.title = undo.length ? 'Undo (' + undo.length + ')' : 'Nothing to undo'; }); }
  function buildDice() {
    var z = $('.kjp-cfg__viewer-controls--zoom'); if (!z) return;
    var row = attr(el('div', 'kjp-cfg__viewer-controls kjs-tools'), { role: 'group', 'aria-label': 'Kit studio tools' });
    var d = attr(el('button', 'kjp-cfg__view-btn kjs-tool'), { type: 'button', 'data-kjs-dice': '' }); d.innerHTML = IC.dice + '<span>Surprise me</span>';
    var u = attr(el('button', 'kjp-cfg__view-btn kjs-tool'), { type: 'button', 'data-kjs-undo': '' }); u.innerHTML = IC.undo + '<span>Undo</span>';
    var c = attr(el('button', 'kjp-cfg__view-btn kjs-tool'), { type: 'button', 'data-kjs-card': '' }); c.innerHTML = IC.card + '<span>Kit card</span>';
    row.appendChild(d); row.appendChild(u); row.appendChild(c);
    var live = attr(el('p', 'kjs-sr'), { 'aria-live': 'polite', 'data-kjs-live': '' }); row.appendChild(live);
    z.parentNode.insertBefore(row, z.nextSibling);
    d.addEventListener('click', surprise);
    u.addEventListener('click', function () { var x = undo.pop(); syncUndo(); x && restoreState(x); });
    c.addEventListener('click', shareCard);
    syncUndo();
  }

  /* ───────────── 9. shareable kit card (1080 x 1350 PNG) ───────────── */
  function loadImg(src) { return new Promise(function (res) { if (!src) return res(null); var i = new Image(); i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = src; }); }
  function siteLogo() {
    var i = $('header img[src*="kibi-logo"], .header img[src*="kibi-logo"], img[alt="KIBI SPORTS"]');
    if (!i) return null; var u = i.currentSrc || i.src; if (!/^https?:\/\/[^/]*kibisports\.com\//.test(u) && !/^\//.test(u)) return null;
    return u.replace(/([?&])width=\d+/, '$1width=240');
  }
  function rr(x, X, Y, W, H, R) { x.beginPath(); x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R); x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath(); }
  function kitCard() {
    var v = cfgV(), s = S(); if (!v || !s) return Promise.resolve(null);
    flush();
    var front = trim(v.snap('front', 1000, null)), back = trim(v.snap('back', 1000, null));
    var fontP = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('400 120px "Bebas Neue"'), document.fonts.load('700 30px "Plus Jakarta Sans"')]).catch(function () {}) : Promise.resolve();
    return Promise.all([fontP, loadImg(siteLogo())]).then(function (r) {
      var logo = r[1];
      try { var t = document.createElement('canvas'); t.width = t.height = 2; var tx = t.getContext('2d'); logo && tx.drawImage(logo, 0, 0, 2, 2); t.toDataURL(); } catch (e) { logo = null; } /* tainted: wordmark only */
      var W = 1080, H = 1350, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var x = cv.getContext('2d'), c = s.colors, st = ST();
      x.fillStyle = '#FDFCFF'; x.fillRect(0, 0, W, H);
      var g = x.createRadialGradient(W / 2, 560, 60, W / 2, 560, 620); g.addColorStop(0, hexA(c.primary, 0.20)); g.addColorStop(1, hexA(c.primary, 0)); x.fillStyle = g; x.fillRect(0, 140, W, 900);
      x.fillStyle = c.primary; x.fillRect(0, 0, W, 14);
      var name = String(s.name || 'Our team').toUpperCase().slice(0, 22);
      x.fillStyle = '#0F0A1E'; x.textBaseline = 'alphabetic'; x.textAlign = 'left';
      var fs = 112; x.font = '400 ' + fs + 'px "Bebas Neue", "Arial Narrow", sans-serif'; while (x.measureText(name).width > W - 128 && fs > 56) { fs -= 4; x.font = '400 ' + fs + 'px "Bebas Neue", "Arial Narrow", sans-serif'; }
      x.fillText(name, 64, 150);
      x.font = '600 30px "Plus Jakarta Sans", Arial, sans-serif'; x.fillStyle = '#67627C';
      var sub = 'Custom ' + (PLABEL[s.product] || 'Kit').toLowerCase() + (st.alt ? ' · ' + (st.k === 'a' ? 'away' : 'home') + ' kit' : '') + (s.number ? ' · #' + String(s.number).slice(0, 3) : '');
      x.fillText(sub, 66, 200);
      [[front, 40, 'Front'], [back, 548, 'Back']].forEach(function (p) {
        if (!p[0]) return; var bx = p[1], by = 250, bw = 492, bh = 760;
        x.save(); rr(x, bx, by, bw, bh, 28); x.fillStyle = 'rgba(255,255,255,.72)'; x.fill(); x.strokeStyle = '#E4E0F0'; x.lineWidth = 2; x.stroke(); x.clip();
        var k = Math.min((bw - 40) / p[0].width, (bh - 80) / p[0].height), dw = p[0].width * k, dh = p[0].height * k;
        x.drawImage(p[0], bx + (bw - dw) / 2, by + (bh - 40 - dh) / 2, dw, dh); x.restore();
        x.font = '700 24px "Plus Jakarta Sans", Arial, sans-serif'; x.fillStyle = '#67627C'; x.textAlign = 'center'; x.fillText(p[2], bx + bw / 2, by + bh - 22); x.textAlign = 'left';
      });
      var sw = [['Primary', c.primary], ['Secondary', c.secondary], ['Accent', c.accent]], sx = 64, sy = 1084;
      x.font = '700 22px "Plus Jakarta Sans", Arial, sans-serif';
      sw.forEach(function (p, i) {
        var X = sx + i * 250; x.beginPath(); x.arc(X + 30, sy + 30, 30, 0, Math.PI * 2); x.fillStyle = p[1]; x.fill(); x.strokeStyle = 'rgba(15,10,30,.18)'; x.lineWidth = 2; x.stroke();
        x.fillStyle = '#0F0A1E'; x.fillText(p[0], X + 74, sy + 24); x.fillStyle = '#67627C'; x.font = '600 22px "Plus Jakarta Sans", Arial, sans-serif'; x.fillText(String(p[1]).toUpperCase(), X + 74, sy + 52); x.font = '700 22px "Plus Jakarta Sans", Arial, sans-serif';
      });
      x.fillStyle = '#E4E0F0'; x.fillRect(64, 1190, W - 128, 2);
      var lx = 64;
      if (logo) { var lh = 64, lw = lh * (logo.naturalWidth || logo.width) / (logo.naturalHeight || logo.height || 1); try { x.drawImage(logo, lx, 1222, lw, lh); lx += lw + 18; } catch (e) {} }
      x.fillStyle = '#0F0A1E'; x.font = '400 52px "Bebas Neue", "Arial Narrow", sans-serif'; x.fillText('KIBI SPORTS', lx, 1272);
      x.textAlign = 'right'; x.fillStyle = '#67627C'; x.font = '600 24px "Plus Jakarta Sans", Arial, sans-serif';
      x.fillText('Designed in 3D at', W - 64, 1242); x.fillStyle = '#5B21B6'; x.font = '700 26px "Plus Jakarta Sans", Arial, sans-serif'; x.fillText('shop.kibisports.com/pages/custom-jerseys', W - 64, 1276);
      return cv;
    }).then(function (cv) {
      return new Promise(function (res) { try { cv.toBlob(function (b) { res(b); }, 'image/png'); } catch (e) { res(null); } });
    });
  }
  function trim(c) {
    if (!c) return c;
    try {
      var w = c.width, h = c.height, d = c.getContext('2d').getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y += 2) for (var x = 0; x < w; x += 2) if (d[(y * w + x) * 4 + 3] > 8) { x < x0 && (x0 = x); x > x1 && (x1 = x); y < y0 && (y0 = y); y > y1 && (y1 = y); }
      if (x1 < 0) return c;
      var m = 12; x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(w, x1 + m); y1 = Math.min(h, y1 + m);
      var o = document.createElement('canvas'); o.width = x1 - x0; o.height = y1 - y0; o.getContext('2d').drawImage(c, x0, y0, o.width, o.height, 0, 0, o.width, o.height); return o;
    } catch (e) { return c; }
  }
  function hexA(h, a) { var c = rgb(h); return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }
  function saveBlob(blob, name) { var u = URL.createObjectURL(blob), a = attr(el('a'), { href: u, download: name }); a.style.display = 'none'; document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(u); a.remove(); }, 1500); }
  function shareCard() {
    var btn = $('[data-kjs-card]'), lbl = btn && $('span', btn), was = lbl && lbl.textContent;
    btn && (btn.disabled = true); lbl && (lbl.textContent = 'Making card…');
    var done = function () { btn && (btn.disabled = false); lbl && (lbl.textContent = was); };
    kitCard().then(function (blob) {
      if (!blob) { done(); return; }
      var f = toFile(blob, 'kibi-kit-card.png'), a = api(), url = a && a.link ? a.link() : location.href;
      var data = { files: [f], title: 'Our KIBI Sports custom kit', text: 'Our custom kit, designed in 3D. Open it here: ' + url };
      if (navigator.canShare && navigator.share && navigator.canShare({ files: [f] })) {
        navigator.share(data).catch(function (e) { e && e.name !== 'AbortError' && saveBlob(blob, 'kibi-kit-card.png'); }).then(done);
      } else { saveBlob(blob, 'kibi-kit-card.png'); done(); }
    }).catch(done);
  }

  /* ───────────── quote: spec lines + files (<= 8 attachments) ───────────── */
  function dataUrlToBlob(d) { var i = d.indexOf(','), b = atob(d.slice(i + 1)), n = b.length, u = new Uint8Array(n); while (n--) u[n] = b.charCodeAt(n); return new Blob([u], { type: (/:(.*?);/.exec(d.slice(0, i)) || [])[1] || 'image/png' }); }
  function bytesOf(d) { return Math.floor((d.length - d.indexOf(',') - 1) * 3 / 4); }
  function toFile(blob, name) { try { return new File([blob], name, { type: blob.type }); } catch (e) { blob.name = name; return blob; } }
  function kitLine(kit) { var c = kit.c, g = kit.g || {}; return 'primary=' + c.primary + ' | secondary=' + c.secondary + ' | accent=' + c.accent + (kit.tc ? ' | name & number=' + kit.tc : '') + (Object.keys(g).length ? ' | ' + GKEYS.filter(function (k) { return g[k]; }).map(function (k) { return GLABEL[k].toLowerCase() + '=' + g[k]; }).join(' | ') : ''); }
  window.KJP_STUDIO_DESC = function () {
    var st = ST(), s = S(), L = [];
    try {
      var pn = (PANELS.filter(function (p) { return p[0] === (st.pn || 'none'); })[0] || PANELS[0])[1];
      L.push('Kit details: panel style ' + pn + ' | ' + GKEYS.map(function (k) { return GLABEL[k].toLowerCase() + ' ' + (hexOk(st[k]) || 'auto'); }).join(' | '));
      L.push('Numbers: back' + (st.fn ? ' + front chest' : '') + (st.sn ? ' + sleeve' : ''));
      var sl = SLOTS.filter(function (x) { return slotFiles[x[0]]; }).map(function (x) { return x[1].toLowerCase() + ' (' + slotFiles[x[0]].name + ')'; });
      L.push('Extra logos: ' + (sl.join(' | ') || 'none'));
      var c = st.cr; L.push('Crest: ' + (c && c.on ? (c.s || 'shield') + ' "' + (c.t || '') + '" fill ' + c.a + ' / letters ' + c.b + (s && s.logo ? ' (uploaded logo shown on the model)' : ' (chest logo)') : 'none'));
      if (st.alt) {
        var cur = captureKit(), home = st.k === 'a' ? st.alt : cur, away = st.k === 'a' ? cur : st.alt;
        L.push('Home kit: ' + kitLine(home) + (st.k === 'a' ? '' : ' (shown)'));
        L.push('Away kit: ' + kitLine(away) + (st.k === 'a' ? ' (shown)' : '') + (st.qb ? ' | QUOTE BOTH KITS' : ' | away kit not quoted'));
      }
      st.sd && L.push('Surprise seed: ' + st.sd);
    } catch (e) {}
    return L.join('\n') || 'Kit details: standard';
  };
  var awayPrep = null;
  function prepAway() {
    awayPrep = null; var st = ST(); if (!st.alt || !st.qb) return;
    try {
      awayPrep = withAlt(function (v) {
        var lbl = st.k === 'a' ? 'home' : 'away', out = [];
        ['front', 'back'].forEach(function (view) { var d = jpegOf(v.snap(view, 900, '#F4F2FA')); d && out.push({ url: d, file: toFile(dataUrlToBlob(d), 'kibi-' + lbl + '-kit-' + view + '.jpg') }); });
        return out;
      });
    } catch (e) { awayPrep = null; }
    var box = $('[data-kjs-qaway]'); if (box) { var im = $('.kjs-qaway__imgs', box); im.replaceChildren(); (awayPrep || []).forEach(function (o) { im.appendChild(attr(el('img'), { src: o.url, alt: 'Other kit preview', width: '40', height: '46' })); }); }
  }
  function modalBox() {
    var st = ST(), anchor = $('[data-kjp-mk]') || $('[data-kjp-qprev]'); if (!anchor) return;
    var box = $('[data-kjs-qaway]');
    if (!box) {
      box = attr(el('div', 'kjs-qaway'), { 'data-kjs-qaway': '' });
      var l = el('label', 'kjs-check'), i = attr(el('input'), { type: 'checkbox', 'data-kjs-qaway-cb': '' });
      l.appendChild(i); l.appendChild(document.createTextNode('Quote the ' + 'away kit too')); box.appendChild(l);
      box.appendChild(el('div', 'kjs-qaway__imgs'));
      i.addEventListener('change', function () { i.checked ? (ST().qb = 1) : delete ST().qb; syncHA(); prepAway(); specRefresh(); });
    }
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    box.hidden = !st.alt;
    $('label', box).lastChild.textContent = 'Quote the ' + (st.k === 'a' ? 'home' : 'away') + ' kit too';
    $('[data-kjs-qaway-cb]', box).checked = !!st.qb;
    prepAway();
  }
  /* the modal's spec text (and the hidden body it submits) were rendered on open: swap in fresh studio lines */
  var SPEC_RE = /^(Kit details|Numbers|Extra logos|Crest|Home kit|Away kit|Surprise seed):/;
  function specRefresh() {
    var fresh = window.KJP_STUDIO_DESC().split('\n');
    [[$('[data-kjp-modal-summary]'), 'textContent'], [$('[data-kjp-quote-body]'), 'value']].forEach(function (p) {
      var e = p[0]; if (!e) return; var lines = String(e[p[1]] || '').split('\n'), at = -1, out = [];
      lines.forEach(function (l) { if (SPEC_RE.test(l)) { at < 0 && (at = out.length); } else out.push(l); });
      if (at < 0) return; out.splice.apply(out, [at, 0].concat(fresh)); e[p[1]] = out.join('\n');
    });
  }
  function wrapExtras() {
    var orig = window.KJP_QUOTE_EXTRAS;
    window.KJP_QUOTE_EXTRAS = function (fd, used) {
      used = used || 0;
      var mine = [], names = [], skipped = [];
      try {
        SLOTS.forEach(function (x) { var f = slotFiles[x[0]]; f && mine.push(toFile(f, 'logo-' + { sp: 'front-sponsor', sl: 'sleeve', nk: 'back-neck' }[x[0]] + '-' + f.name.replace(/[^\w.\-]+/g, '_').slice(-60))); });
        /* priority: logo slots, crest when it IS the chest logo, the other kit (quote both), crest when a logo was uploaded */
        var cf = crestFile(), s0 = S(), logoUp = !!(s0 && s0.logo);
        cf && !logoUp && mine.push(cf);
        var st0 = ST(); st0.alt && st0.qb && (awayPrep || []).forEach(function (o) { mine.push(o.file); });
        cf && logoUp && mine.push(cf);
      } catch (e) {}
      var room = Math.max(0, MAX_ATT - used), reserve = Math.min(mine.length, Math.max(0, room - 2)); /* 2 left for the design front/back */
      mine.forEach(function (f, i) { if (i < reserve) { fd.append('contact[attachment_' + (used + i + 1) + ']', f, f.name); names.push(f.name); } else skipped.push(f.name); });
      var n = 0;
      try { n = orig ? (orig(fd, used + reserve) || 0) : 0; } catch (e) {}
      var total = reserve + n;
      try {
        var st = ST(), body = String(fd.get('contact[body]') || '');
        st.alt && st.qb && !(awayPrep || []).length && (body += '\nOther kit previews unavailable (the spec above lists its colours)');
        names.length && (body += '\nKit studio files attached: ' + names.join(', '));
        skipped.length && (body += '\nKit studio files not attached (8-file limit; please send by reply): ' + skipped.join(', '));
        fd.set('contact[body]', body);
      } catch (e) {}
      return total;
    };
  }

  /* ───────────── wiring ───────────── */
  function syncAll() { syncPanels(); syncGranular(); syncNumbers(); syncCrest(); syncHA(); meterSoon(); }
  function init() {
    var root = $('[data-kjp]'); if (!root || !api()) return;
    ST();
    try { buildPanels(); } catch (e) {}
    try { buildGranular(); } catch (e) {}
    try { buildHomeAway(); } catch (e) {}
    try { buildNumbers(); } catch (e) {}
    try { var at = $('[data-kjp-attach-list]'), f = at && at.closest('.kjp-field'); if (f) { var sw = buildSlots(f); buildCrest(sw); } } catch (e) {}
    try { buildDice(); } catch (e) {}
    try { buildMeter(); buildNudge(); } catch (e) {}
    wrapExtras();
    syncAll(); refresh();
    /* track what the shopper has chosen (meter) and keep derived swatches in step with the main colours */
    root.addEventListener('input', function (e) { var t = e.target; if (!t || !t.matches) return; t.matches('[data-kjp-color]') && (touched.colors = 1, syncGranular()); meterSoon(); }, true);
    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null; if (!t) return;
      t.closest('[data-kjp-combo],[data-kjp-preset]') && (touched.colors = 1, setTimeout(syncGranular, 0));
      t.closest('[data-kjp-pattern],[data-kjp-premium],[data-kjp-preset]') && (touched.style = 1);
      t.closest('[data-kjp-product]') && setTimeout(syncGranular, 0);
      meterSoon();
    });
    root.addEventListener('change', meterSoon, true);
    var qb = $('[data-kjp-quote-btn]', root), ov = $('[data-kjp-overlay]');
    qb && qb.addEventListener('click', function () { setTimeout(function () { ov && ov.classList.contains('open') && modalBox(); }, 60); });
    /* the meter also counts the matching-kit ticks inside the quote modal */
    ov && ov.addEventListener('change', meterSoon);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  window.KJP_STUDIO_API = { kitCard: kitCard, roll: roll, surprise: surprise, toggleKit: toggleKit, compare: compare, meter: function () { meter(); return checks(); }, undoDepth: function () { return undo.length; }, awayOf: awayOf, crestFile: crestFile };
})();
